import { Button } from "@mui/material";
import React from "react";
import { node } from "prop-types";

type BlueButtonStyleHeadingProps = React.ComponentProps<typeof Button>;

export const BlueButtonStyleHeading = (props: BlueButtonStyleHeadingProps) => {
  return (
    <Button
      sx={{
        backgroundColor: (theme) => theme.palette.primary.light,
        fontWeight: "700",
        borderRadius: 50,
        paddingX: "15px",
      }}
    >
      {props.children}
    </Button>
  );
};

BlueButtonStyleHeading.propTypes = {
  children: node,
};
